import React, { useState } from 'react';

const ScraperForm = ({ 
  onSubmit, 
  location, 
  setLocation, 
  query, 
  setQuery, 
  category, 
  setCategory, 
  format, 
  setFormat, 
  scrolls, 
  setScrolls, 
  loading,
  isAuthenticated,
  onSignInClick 
}) => {
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    const newErrors = { ...errors };
    
    switch (name) {
      case 'location':
        if (!value.trim()) {
          newErrors.location = 'Location is required';
        } else if (value.length < 2) {
          newErrors.location = 'Location must be at least 2 characters';
        } else if (value.length > 100) {
          newErrors.location = 'Location must be less than 100 characters';
        } else {
          delete newErrors.location;
        }
        break;
      
      case 'query':
        if (!value.trim()) {
          newErrors.query = 'Search query is required';
        } else if (value.length < 2) {
          newErrors.query = 'Search query must be at least 2 characters';
        } else if (value.length > 100) {
          newErrors.query = 'Search query must be less than 100 characters';
        } else {
          delete newErrors.query;
        }
        break;
      
      case 'category':
        if (!value.trim()) {
          newErrors.category = 'Category is required';
        } else if (value.length < 2) {
          newErrors.category = 'Category must be at least 2 characters';
        } else if (value.length > 50) {
          newErrors.category = 'Category must be less than 50 characters';
        } else {
          delete newErrors.category;
        }
        break;
      
      case 'scrolls':
        const scrollValue = parseInt(value);
        if (isNaN(scrollValue)) {
          newErrors.scrolls = 'Must be a valid number';
        } else if (scrollValue < 0) {
          newErrors.scrolls = 'Must be 0 or greater';
        } else if (scrollValue > 100) {
          newErrors.scrolls = 'Maximum 100 scrolls allowed';
        } else {
          delete newErrors.scrolls;
        }
        break;
      
      default:
        break;
    }
    
    setErrors(newErrors);
  };

  const handleSubmitWithValidation = (e) => {
    e.preventDefault();
    
    // Validate all fields before submission
    validateField('location', location);
    validateField('query', query);
    validateField('category', category);
    validateField('scrolls', scrolls);
    
    // Check if there are any errors
    if (Object.keys(errors).length === 0 && 
        location.trim() && 
        query.trim() && 
        category.trim() && 
        scrolls >= 0) {
      onSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmitWithValidation} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      {!isAuthenticated && (
        <div
          style={{
            backgroundColor: '#fff3cd',
            color: '#856404',
            padding: '15px',
            borderRadius: '4px',
            border: '1px solid #ffeaa7',
            marginBottom: '10px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <span>Please sign in first to use the scraper.</span>
          <button
            type="button"
            onClick={onSignInClick}
            style={{
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Sign In
          </button>
        </div>
      )}
      
      <div>
        <label htmlFor="location" style={{ display: 'block', marginBottom: '5px' }}>
          Location: <span style={{ color: 'red' }}>*</span>
        </label>
        <input
          type="text"
          id="location"
          value={location}
          onChange={(e) => {
            setLocation(e.target.value);
            validateField('location', e.target.value);
          }}
          onBlur={(e) => validateField('location', e.target.value)}
          required
          disabled={!isAuthenticated}
          minLength={2}
          maxLength={100}
          style={{ 
            width: '100%', 
            padding: '8px', 
            opacity: isAuthenticated ? 1 : 0.6,
            borderColor: errors.location ? '#d32f2f' : '#ddd'
          }}
        />
        {errors.location && (
          <span style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px', display: 'block' }}>
            {errors.location}
          </span>
        )}
      </div>
      
      <div>
        <label htmlFor="search_query" style={{ display: 'block', marginBottom: '5px' }}>
          Search Query: <span style={{ color: 'red' }}>*</span>
        </label>
        <input
          type="text"
          id="search_query"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            validateField('query', e.target.value);
          }}
          onBlur={(e) => validateField('query', e.target.value)}
          required
          disabled={!isAuthenticated}
          minLength={2}
          maxLength={100}
          style={{ 
            width: '100%', 
            padding: '8px', 
            opacity: isAuthenticated ? 1 : 0.6,
            borderColor: errors.query ? '#d32f2f' : '#ddd'
          }}
        />
        {errors.query && (
          <span style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px', display: 'block' }}>
            {errors.query}
          </span>
        )}
      </div>
      
      <div>
        <label htmlFor="category" style={{ display: 'block', marginBottom: '5px' }}>
          Category: <span style={{ color: 'red' }}>*</span>
        </label>
        <input
          type="text"
          id="category"
          value={category}
          onChange={(e) => {
            setCategory(e.target.value);
            validateField('category', e.target.value);
          }}
          onBlur={(e) => validateField('category', e.target.value)}
          required
          placeholder="e.g., Restaurant, Salon, Gym"
          disabled={!isAuthenticated}
          minLength={2}
          maxLength={50}
          style={{ 
            width: '100%', 
            padding: '8px', 
            opacity: isAuthenticated ? 1 : 0.6,
            borderColor: errors.category ? '#d32f2f' : '#ddd'
          }}
        />
        {errors.category && (
          <span style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px', display: 'block' }}>
            {errors.category}
          </span>
        )}
      </div>
      
      <div>
        <label htmlFor="format" style={{ display: 'block', marginBottom: '5px' }}>Format:</label>
        <select
          id="format"
          value={format}
          onChange={(e) => setFormat(e.target.value)}
          disabled={!isAuthenticated}
          style={{ width: '100%', padding: '8px', opacity: isAuthenticated ? 1 : 0.6 }}
        >
          <option value="csv">CSV</option>
          <option value="json">JSON</option>
        </select>
      </div>
      
      <div>
        <label htmlFor="scrolls" style={{ display: 'block', marginBottom: '5px' }}>
          Number of Scrolls: <span style={{ color: 'red' }}>*</span>
        </label>
        <input
          type="number"
          id="scrolls"
          value={scrolls}
          onChange={(e) => {
            const value = Math.max(0, parseInt(e.target.value) || 0);
            setScrolls(value);
            validateField('scrolls', value);
          }}
          onBlur={(e) => validateField('scrolls', e.target.value)}
          min="0"
          max="100"
          required
          disabled={!isAuthenticated}
          style={{ 
            width: '100%', 
            padding: '8px', 
            opacity: isAuthenticated ? 1 : 0.6,
            borderColor: errors.scrolls ? '#d32f2f' : '#ddd'
          }}
        />
        {errors.scrolls && (
          <span style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px', display: 'block' }}>
            {errors.scrolls}
          </span>
        )}
      </div>
      
      <button 
        type="submit" 
        disabled={loading || !isAuthenticated}
        style={{
          padding: '10px',
          backgroundColor: isAuthenticated && !loading ? '#007bff' : '#ccc',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: (loading || !isAuthenticated) ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Scraping...' : 'Start Scraping'}
      </button>
    </form>
  );
};

export default ScraperForm;
